<script setup>
import { computed } from 'vue'
import { publicConfig } from '@/config/runtime'

const SIZE_CLASSES = {
    xs: 'logo-xs',
    s: 'logo-s',
    m: 'logo-m',
    l: 'logo-l',
}

const props = defineProps({
    isLinkedToHome: {
        type: Boolean,
        default: true,
    },
    size: {
        type: String,
        default: 's', // 'xs', 's', 'm', 'l'
    },
    hasLabel: {
        type: Boolean,
        default: true,
    },
    hasMargin: {
        type: Boolean,
        default: true,
    },
})

const sizeClass = computed(() => SIZE_CLASSES[props.size])

const logoText = computed(() => publicConfig().logoText || '')
</script>
<template>
    <div :class="['logo', sizeClass, !hasMargin && 'logo-no-margin']">
        <BaseLink
            v-if="isLinkedToHome"
            :to="{ path: '/' }"
            class="logo-link"
        >
            Frisky
            <span
                v-if="hasLabel && logoText"
                class="logo-text"
            >{{ logoText }}</span>
        </BaseLink>
        <div
            v-else
            class="logo-link"
        >
            Frisky
            <span
                v-if="hasLabel && logoText"
                class="logo-text"
            >{{ logoText }}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.logo {
    @extend %h1;

    display: inline-block;
    margin-top: 0;
    margin-bottom: $s-s; // the old h1 mixin carried this; logo-no-margin relies on it
    font-weight: 800;
    vertical-align: bottom;
    text-transform: uppercase;
    letter-spacing: 0; // the FRISKY wordmark is not tracked like Display text

    &.logo-no-margin {
        margin-bottom: 0;
    }

    &.logo-xs {
        font-size: 20px;
        line-height: 20px;
    }

    &.logo-s {
        font-size: 30px;
        line-height: 30px;
    }

    &.logo-m {
        font-size: 50px;
        line-height: 50px;
    }

    &.logo-l {
        font-size: 80px;
        line-height: 80px;
    }

    &-link {
        &:hover,
        &:active {
            text-decoration: none;
        }

        &,
        &:visited {
            color: $c-white;
        }
    }

    &-text {
        position: relative;
        top: -4px;
        display: inline-block;
        padding: 1px 3px 1px 2px;
        font-size: 12px;
        font-weight: 500;
        line-height: 1;
        vertical-align: bottom;
        color: $c-black;
        text-transform: capitalize;
        background: $c-text-secondary;
        border-radius: $radius-3;
    }
}
</style>
